import { Coordinates } from '~/utils/calculate-distance';

export function getGoogleMapLink(coordinates?: Coordinates): string {
  return `https://maps.google.com/?q=${coordinates?.lat || ''},${
    coordinates?.lng || ''
  }`;
}
